import { FC } from 'react';
import { IContextBreakdownMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionDonut } from '../../../../shared/charts/DistributionDonut';
import { DistributionSlice } from '../../../../shared/charts/chart.types';
import { getPaletteColor } from './_shared/chartPalette';

interface Props {
  data: IContextBreakdownMetric | null;
  period?: string;
  height?: number;
}

export const ContextBreakdownChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.items || data.items.length === 0) {
    return <ChartEmptyState />;
  }

  const slices: DistributionSlice[] = data.items.map((item, index) => ({
    id: item.context,
    label: item.context,
    value: item.count,
    percent: Math.round(item.pct),
    color: getPaletteColor(index),
  }));

  return <DistributionDonut data={slices} height={height} valueFormatter={(v) => `${v}`} />;
};
